import { render, staticRenderFns } from "./cmpconsultaestoquepro2.vue?vue&type=template&id=65b913c1&"
import script from "./cmpconsultaestoquepro2.vue?vue&type=script&lang=js&"
export * from "./cmpconsultaestoquepro2.vue?vue&type=script&lang=js&"
import style0 from "./cmpconsultaestoquepro2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports